import React, { useState, useEffect, useRef } from 'react';
import { useIntl, connect, history, getLocale } from 'umi';
import { Layout, Card, SearchBox, Table, Bubble, ConfigProvider } from 'tea-component';
import { getSubscribeManagerTable } from '../../services/substribe';
import { useBuriedPoint } from '@/pages/home/utils/customHook';
import { useSubscribeManagerTableMap } from "@/pages/dashboard/pages/subscribe/_config/constant";
import { getUTCTime, getFrequencyStr } from '@/pages/dashboard/pages/subscribe/_config/utils';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import TableHandleButtons from './components/TableHandleButtons';
import BubbleEllipsis from '../../components/BubbleEllipsis';

import '@/pages/dashboard/assets/scss/page/Subscribe/subscribe.scss';
import '@/pages/dashboard/assets/scss/page/Subscribe/subscribeManage.scss';
import ACard from '../../components/ACard';


const { Content } = Layout;
const { pageable, autotip } = Table.addons;

const SubscriptionManage = (props: any) => {
  const { gameCode, subscribeOutSideEnable } = props || {};
  const { formatMessage } = useIntl();
  const { query } = history.location;
  const { subscribeId }: any = query || {};
  const isInit = useRef(true);
  const { PUSH_RESULT, PUSH_METHOD, CURRENT_STATE, SUBSCRIBE_REQUEST_OPTIONS, WEEK_TEXT, TIME_TEXT } = useSubscribeManagerTableMap();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const [keyword, setKeyword] = useState(""); // 搜索输入框受控字段
  const [paging, setPaging] = useState({ pageIndex: 1, pageSize: 10 });
  const [total, setTotal] = useState(0);
  const [records, setRecords] = useState([]);

  // 打点信息
  const logObj = {
    pageId: '202301',
    pageName: 'subscribeManage',
    extInfo: 'subscribeManage',
    pagePath: '/subscribe/subscribeManage',
    uid: gameCode,
    uidType: 'game_code'
  };
  useBuriedPoint(logObj);

  useEffect(() => {
    getTableData();
  }, []);

  // 获取表格数据
  const getTableData = (pageIndex = paging.pageIndex, pageSize = paging.pageSize, clearSearchWord = false) => {
    const params = {
      game_code: gameCode,
      search_keyword: clearSearchWord ? "" : keyword,
      page: pageIndex,
      page_size: pageSize,
      // subscribeId:订阅号，和后端沟通后：从url中获取传过来， 没有就不传或者传空
      // 应产品要求，从邮件url进来，第一次展示退订的那一条数据，后续返回原列表，搜索等都是返回全量数据，传''
      subscribe_id: isInit.current ? (subscribeId || '') : ''
    };
    setRecords([]);
    setLoading(true);
    setError(null);
    getSubscribeManagerTable(params).then((response) => {
      isInit.current = false;
      setRecords(response?.list || []);
      setTotal(response?.total);
    }).catch((e) => {
      setError({ code: e?.code, msg: e?.msg });
      console.log("订阅管理页面表格接口错误: ", e);
    }).finally(() => setLoading(false));
  };

  const jumpToSubPages = (jumpUrl: string) => {
    const pathStr = jumpUrl?.split('/v2')?.[1];
    // window.location.href只是个兜底，防止后面v2去掉或者从其他地方（比如现在开发的时候，老版本的数据也会有，后期会做数据隔离）订阅后跳转异常
    pathStr ? history.push(pathStr) : window.location.href = jumpUrl;
  };

  return (
    <Content className='dbd-subscribemanage'>
      <ConfigProvider locale={getLocale() === 'zh-CN' ? 'zh' : "en"}>
        <Content.Header
          showBackButton
          title={formatMessage({ id: "subscribe_manager_title" })}
          onBackButtonClick={() => {
            history.goBack();
          }}
        >
        </Content.Header>

        <Content.Body full>
          <div className='subscribemanage-search'>
            <SearchBox
              className='subscribemanage-search-item'
              disabled={loading}
              value={keyword}
              onChange={value => setKeyword(value)}
              onSearch={() => {
                // 当搜索时, 重置页数, paging改变会触发useEffect, 重新请求表格数据
                setPaging({ pageSize: paging.pageSize, pageIndex: 1 });
                getTableData(1, paging.pageSize);
              }}
              onClear={() => setKeyword("")}
              placeholder={formatMessage({ id: "subscribe_manager_search" })}
            />
          </div>
          <Card className='dbd-subscribemanage-table'>
            <Card.Body>
              <Table
                className="dbd-subscribe-table"
                records={records}
                columns={[
                  {
                    key: "subscribe_name",
                    header: formatMessage({ id: "subscribe_manager_subscribe_reports" }),
                    width: 300,
                    render: (cvm: any) => {
                      const { subscribe_content } = cvm || {};
                      return (
                        <ACard url={subscribe_content?.split('/v2')?.[1]}>
                          < BubbleEllipsis
                            content={<div className='table-flex-text-dashboard dbd-subscribe-bubble' onClick={() => jumpToSubPages(subscribe_content)}>{cvm.subscribe_name}</div>}
                            maxWidth={260}
                          />
                        </ACard>
                      );
                    }
                  },
                  {
                    key: "subscribe_title",
                    header: formatMessage({ id: "subscribe_manager_push_title" }),
                    width: 143,
                    render: (record: any) => <BubbleEllipsis
                      content={<div className='table-text dbd-subscribe-bubble'>{record.subscribe_title}</div>}
                      maxWidth={103}
                    />
                  },
                  {
                    key: "last_push_time",
                    header: formatMessage({ id: "subscribe_manager_last_push_time" }),
                    width: 206,
                    render: (record: any) => <div className='table-text'>{getUTCTime(record?.last_push_time) || "-"}</div>
                  },
                  {
                    key: "send_status",
                    header: formatMessage({ id: "subscribe_manager_push_result" }),
                    width: 156,
                    render: record => {
                      const result = PUSH_RESULT[record?.send_status];
                      // 0：未推送 1:推送成功 2:推送失败 3:部分推送成功 4：推送中
                      return <div className='table-flex'>
                        {/* 迁移重构的代码结构,并优化判断逻辑 */}
                        <div className={result?.className}>{result?.text}</div>
                        {
                          record?.send_status == '3' ? <Bubble content={
                            <div className='dbd-table-topic'>
                              <div className='dbd-table-topic-title'>{formatMessage({ id: "subscribe_manager_push_result_fail_info" })}</div>
                              <div className='dbd-table-topic-text'>{record?.receiver_fail?.replace(",", "，")}</div>
                            </div>
                          } dark>
                            <div className='dbd-table-topic-icon'>
                              <TipContext />
                            </div>
                          </Bubble> : ''
                        }
                      </div>;
                    },
                  },
                  {
                    key: "send_type",
                    header: formatMessage({ id: "subscribe_manager_push_method" }),
                    width: 148,
                    render: (record: any) => <div className='table-text'>{record.send_type?.split(",")?.map((type: string | number) => PUSH_METHOD[type])?.join(",")}</div>
                  },
                  {
                    key: "frequency_type", // 需要前端拼接 frequency_type, frequency_time, frequency_interval
                    header: formatMessage({ id: "subscribe_manager_push_frequency" }),
                    width: 121,
                    render: (record: any) => <BubbleEllipsis
                      content={<div className='table-text dbd-subscribe-bubble'>{getFrequencyStr(record, formatMessage, WEEK_TEXT, TIME_TEXT)}</div>}
                      maxWidth={81}
                    />
                  },
                  {
                    key: "viewport_width",
                    header: formatMessage({ id: "subscribe_setting_viewport_width", defaultMessage: "页面宽度" }),
                    width: 121,
                    render: (record: any) => <div className='table-text'>{record.viewport_width || '-'}</div>
                  },
                  {
                    key: "subscribe_status", // 1代表订阅中, 0代表已退订
                    header: formatMessage({ id: "subscribe_manager_current_state" }),
                    width: 156,
                    render: record => {
                      const state = CURRENT_STATE[record?.subscribe_status];
                      return (
                        <div className={state?.className}>{state?.text}</div>
                      );
                    },
                  },
                  {
                    key: "opts",
                    header: formatMessage({ id: "subscribe_manager_handle" }),
                    width: 365,
                    fixed: "right",
                    render: record => (<TableHandleButtons record={record} gameCode={gameCode} refreshTable={getTableData} setTableLoading={() => { setLoading(true);setRecords([]) }} subscribeRequestOptions={SUBSCRIBE_REQUEST_OPTIONS} subscribeOutSideEnable={subscribeOutSideEnable} />),
                  },
                ]}
                addons={[
                  autotip({
                    isLoading: loading,
                    // 转为boolean类型!! 
                    isError: !!error,
                    hideIcon: !loading,
                    isFound: total === 0, // 是否显示
                    foundText: formatMessage({ id: "common_not_found" }),
                    loadingText: formatMessage({ id: "common_loading" }), // 加载文案
                    emptyText: formatMessage({ id: "common_nodata" }), // 空数据文案
                    errorText: formatMessage({ id: "common_loading_failed" }),
                    retryText: formatMessage({ id: "common_retry_table" }), // 重试文案
                    clearResultText: formatMessage({ id: "common_go_back_table" }), // 清空结果文案
                    onRetry: () => { getTableData() },
                    onClear: () => {
                      // 搜索结果为空时, 显示返回原列表按钮
                      setKeyword("");
                      // 返回原列表后则获取全量数据
                      getTableData(paging.pageIndex, paging.pageSize, true,);
                    },
                    style: { lineHeight: '200px' },
                  }),
                  pageable({
                    recordCount: total,
                    pageIndex: paging.pageIndex,
                    pageSize: paging.pageSize,
                    stateText: total > 10 ? `${total} ${formatMessage({ id: 'common_records' })}` : '',
                    pageSizeOptions: [10, 20, 30, 40, 50],
                    stateTextVisible: total > 10,
                    pageSizeVisible: total > 10,
                    pageIndexVisible: total > 10,
                    jumpVisible: total > 10,
                    endJumpVisible: total > 10,
                    onPagingChange(query) {
                      getTableData(query.pageIndex, query.pageSize);
                      setPaging({ pageIndex: query.pageIndex, pageSize: query.pageSize });
                    }
                  }),
                  // scrollable({minWidth: 1334})
                ]}
              />
            </Card.Body>
          </Card>
        </Content.Body>
      </ConfigProvider>
    </Content >
  );
};

export default connect((state: any) => ({
  gameCode: state.dashboard?.currentGame?.game_code,
  subscribeOutSideEnable: state?.dashboardSetting?.gameConfig?.subscribe_out_side_enable
}))(SubscriptionManage);
